import { useQuery } from '@tanstack/react-query';
import { getRoverDeliverables } from '@/api/Rover/applicationTDM';
import type { IGetDeliverablesServiceRes } from '@/api/Sherpa/Project/modules/ProjectTdm/types';
import { getDeliverables } from '../../../api/Sherpa/Project/modules/ProjectTdm';
import { TdmReactQueryKey } from '../../../constants/ReactQueryKeys';
import { sherpaTdmListQueryKey } from '../../../features/projects/query-cache';
import type { QueryParamsInterface } from '../../../types/Shared';

interface IDeliverablesHookProps {
  params?: QueryParamsInterface;
  onSuccess?: (data: any) => void;
  onError?: (data: any) => void;
  select?: (data: IGetDeliverablesServiceRes) => any;
  enabled?: boolean;
}

export const useDeliverables = ({ params, onSuccess, onError, select, enabled = true }: IDeliverablesHookProps) => {
  //Tanstack: version 5 query implementation
  return useQuery<IGetDeliverablesServiceRes>({
    queryKey: sherpaTdmListQueryKey('deliverable', params),
    queryFn: () => getDeliverables({ params }),
    onSuccess,
    onError,
    select,
    keepPreviousData: true,
    staleTime: 30000,
    enabled,
  });
};

export const useRoverDeliverables = ({ params, onSuccess, onError }: IDeliverablesHookProps) => {
  //Tanstack: version 5 query implementation
  return useQuery({
    queryKey: [TdmReactQueryKey.GET_APPLICATION_DELIVERABLES, params],
    queryFn: () => getRoverDeliverables({ params }),
    onSuccess,
    onError,
    keepPreviousData: true,
    staleTime: 30000,
  });
};
